export enum Keys {
    SETTINGS = "MON_settings",
    CUSTOMER_TYPE = "MON_customertype",
}
